import React, { Component } from 'react'
// import { Image, Segment } from 'semantic-ui-react'
import FeatureCards from '../components/FeatureCards'
import DataStatistics from '../components/DataStatistics'

class HomeContainer extends Component {

  render() {
    return(
      <div>
          <div>
            <div id='landing-page'>
              <br/>
              <br/>
              <br/>
              <div id="title" className='home-text'>
                <span style={{fontSize: '0.85em', color:'#ffffff'}}>{`{`}&nbsp;</span><div style={{display: 'inline'}} ><div style={{display: 'inline', fontSize: '0.85em', color:'#ffffff'}}><img src='/white-logo.png' alt='logo' style={{width: '48px', height: '48px', margin: '0px 0px -10px 0px'}} />{`DREAM`}</div><div style={{display: 'inline', fontSize: '0.85em', color:'#88f2e8'}}>TEAM</div></div><span style={{fontSize: '0.85em', color:'#ffffff'}}>&nbsp;{`}`}</span>
              </div>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
              <br/>
            </div>
          </div>
          <div className='ui container'>
            <div>
              <br/>
              <DataStatistics />
              <br/>
            </div>
            <FeatureCards />
          </div>
      </div>
    )
  }

}

export default HomeContainer



// WEBPACK FOOTER //
// ./src/containers/HomeContainer.js